import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { contextConnect, useContextSystem } from '@wp-g2/context';
import React from 'react';
import { Button } from '../Button';
import { useHistory } from './Router';

function NavigatorButton(props, forwardedRef) {
  var _useContextSystem = useContextSystem(props, 'NavigatorButton'),
      as = _useContextSystem.as,
      children = _useContextSystem.children,
      exact = _useContextSystem.exact,
      href = _useContextSystem.href,
      isBack = _useContextSystem.isBack,
      isPlain = _useContextSystem.isPlain,
      params = _useContextSystem.params,
      showArrow = _useContextSystem.showArrow,
      to = _useContextSystem.to,
      otherProps = _objectWithoutProperties(_useContextSystem, ["as", "children", "exact", "href", "isBack", "isPlain", "params", "showArrow", "to"]);

  var history = useHistory();

  var handleOnClick = function (event) {
    event.preventDefault();

    if (isBack) {
      if (to) {
        history.push(to, {
          isBack: true
        });
      } else {
        history.goBack();
      }
    } else {
      history.push(to);
    }
  };

  if (!to) {
    return /*#__PURE__*/React.createElement(Button, Object.assign({
      href: href || '#',
      ref: forwardedRef
    }, otherProps, {
      onClick: handleOnClick
    }), children);
  }

  return /*#__PURE__*/React.createElement(Button, Object.assign({}, otherProps, {
    exact: exact,
    onClick: handleOnClick,
    ref: forwardedRef
  }), children);
}

export default contextConnect(NavigatorButton, 'NavigatorButton');